export default "__VITE_ASSET__Dvs4pe4D__"